import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import styled from 'styled-components/native';
import Dialog, { DialogProps } from '../Dialog/Dialog';

interface Props extends DialogProps {
  value?: string;
  onSelect(minute: string): void;
}

export const SelectMinuteDialog = ({ value, onSelect, ...rest }: Props) => {
  return (
    <Dialog size="mc" {...rest}>
      <Heading>
        <Text variant="h3" weight="semibold">
          Select minute
        </Text>
      </Heading>

      <Row>
        {minutes.slice(0, 10).map((minute) => (
          <MinuteButton
            key={minute}
            minute={minute}
            selected={minute === value}
            onPress={onSelect}
          />
        ))}
      </Row>
      <Row>
        {minutes.slice(10, 20).map((minute) => (
          <MinuteButton
            key={minute}
            minute={minute}
            selected={minute === value}
            onPress={onSelect}
          />
        ))}
      </Row>
      <Row>
        {minutes.slice(20, 30).map((minute) => (
          <MinuteButton
            key={minute}
            minute={minute}
            selected={minute === value}
            onPress={onSelect}
          />
        ))}
      </Row>
      <Row>
        {minutes.slice(30, 40).map((minute) => (
          <MinuteButton
            key={minute}
            minute={minute}
            selected={minute === value}
            onPress={onSelect}
          />
        ))}
      </Row>
      <Row>
        {minutes.slice(40, 50).map((minute) => (
          <MinuteButton
            key={minute}
            minute={minute}
            selected={minute === value}
            onPress={onSelect}
          />
        ))}
      </Row>
      <Row>
        {minutes.slice(50, 60).map((minute) => (
          <MinuteButton
            key={minute}
            minute={minute}
            selected={minute === value}
            onPress={onSelect}
          />
        ))}
      </Row>

      <Bottom>
        <Button variant="text" onPress={rest.onClose}>
          Cancel
        </Button>
      </Bottom>
    </Dialog>
  );
};

interface MinuteButtonProps {
  minute: string;
  selected?: boolean;
  onPress(minute: string): void;
}

export const MinuteButton = ({
  onPress,
  minute,
  selected,
}: MinuteButtonProps) => {
  const press = () => onPress(minute);

  return (
    <Minute onPress={press} selected={selected}>
      <Text weight="semibold" color={selected ? 'white' : undefined}>
        {minute}
      </Text>
    </Minute>
  );
};

const Heading = styled.View`
  align-items: center;
  padding: 15px;
`;

const Row = styled.View`
  flex-direction: row;
`;

const Bottom = styled.View`
  flex-direction: row;
  padding: 10px 32px;
`;

const Minute = styled.TouchableOpacity<{ selected?: boolean }>`
  width: 80px;

  padding: 10px;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-color: lightgrey;

  ${({ selected }) =>
    selected ? `background-color: ${colors.primary[700]};` : ''}
`;

const minutes = [...Array(60)].map((_, idx) => {
  return idx.toString().padStart(2, '0');
});
